import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refunds from "@/pages/Refunds";
import Shipping from "@/pages/Shipping";
import Contact from "@/pages/Contact";
import Company from "@/pages/Company";
import Cookies from "@/pages/Cookies";
import Success from "@/pages/Success";
import Login from "@/pages/Login";
import Signal from "@/pages/Signal";
import AccessHistory from "@/pages/AccessHistory";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]">
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
          Ivory Pulse
        </span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

const HistoryAdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.can_view_access_history ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App bg-[#050505] text-white font-body">
      <div className="noise-overlay" aria-hidden="true" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signal" element={<Protected><Signal /></Protected>} />
            <Route path="/" element={<Protected><Signal /></Protected>} />
            <Route path="/admin/access-history" element={<Protected><HistoryAdminOnly><AccessHistory /></HistoryAdminOnly></Protected>} />
            <Route path="/terms" element={<Protected><Terms /></Protected>} />
            <Route path="/privacy" element={<Protected><Privacy /></Protected>} />
            <Route path="/refunds" element={<Protected><Refunds /></Protected>} />
            <Route path="/shipping" element={<Protected><Shipping /></Protected>} />
            <Route path="/contact" element={<Protected><Contact /></Protected>} />
            <Route path="/company" element={<Protected><Company /></Protected>} />
            <Route path="/cookies" element={<Protected><Cookies /></Protected>} />
            <Route path="/success" element={<Protected><Success /></Protected>} />
            <Route path="*" element={<Protected><Navigate to="/" replace /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="bottom-center" theme="dark" />
    </div>
  );
}

export default App;
